var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.4 308.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006DF0",
    d: "M273.6 22.8C258.4 7.6 238 0 218 0s-40.4 8-55.6 23.2L15.2 170.4c-4.8 4.8-4.8 12.4 0 17.2s12.4 4.8 17.2 0L179.6 40C190.4 29.2 204 24 218 24s27.6 5.2 38.4 16 16 24.4 16 38.4-5.2 27.6-16 38.4L98.8 274.4c-6.4 6.4-15.2 9.6-23.6 9.6s-17.2-3.2-23.6-9.6c-6.4-6.4-9.6-15.2-9.6-23.6 0-8.4 3.2-16.8 9.6-23.6L204 74.4c2.4-2.4 5.2-3.6 8.4-3.6s6 1.2 8.4 3.6c2.4 2.4 3.6 5.2 3.6 8.4s-.8 6-3.2 8.4L78.4 234c-4.8 4.8-4.8 12.4 0 17.2s12.4 4.8 17.2 0L238 108.4l.4-.4.4-.4c6.8-6.8 10-16 10-24.8 0-9.2-3.2-18.4-10.4-25.6-7.2-6.8-16.4-10.4-25.6-10.4s-18.4 3.2-25.6 10.4L34.4 210c-11.2 11.2-16.8 26-16.8 40.8s5.6 29.6 16.8 40.8c11.2 11.2 26 16.8 40.8 16.8s29.6-5.6 40.8-16.8L273.6 134c15.6-15.2 23.2-35.6 23.2-55.6s-8-40.4-23.2-55.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.661687503b6909582d0ca03277ccf785.svg";
export { ForwardRef as ReactComponent };